import { render, staticRenderFns } from "./SelectionOfTheOffer.vue?vue&type=template&id=4e83ffa7&scoped=true&"
import script from "./SelectionOfTheOffer.vue?vue&type=script&lang=js&"
export * from "./SelectionOfTheOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e83ffa7",
  null
  
)

export default component.exports